
export default class Messages {

	constructor(selector = '.js-message', speed = 80) {

		this.selector = selector;

		this.speed = speed;

		this.instances = [];

		this.resizeTimer = null;

		this.resizeHandler = null;

	}

	/*
	** load
	*/

	load() {

		const messages = document.querySelectorAll(this.selector);

		if (! messages.length) return;

		requestAnimationFrame(() =>
		{
			messages.forEach((message) =>
			{
				const track = message.querySelector('.message__track');
				const original = track?.querySelector('.message__content');

				if (!track || !original) return;

				this._resetTrack(track);

				const originalWidth = original.offsetWidth;

				if (!originalWidth) return;

				const screenWidth = window.innerWidth;

				const copiesNeeded = Math.ceil((screenWidth * 2) / originalWidth);

				for (let i = 0; i < copiesNeeded; i++)
				{
					const clone = original.cloneNode(true);
					clone.setAttribute('aria-hidden', 'true');
					track.appendChild(clone);
				}

				track.style.setProperty('--marquee-distance', `${-originalWidth}px`);

				const duration = originalWidth / this.speed;

				track.style.animation = `marquee ${duration}s linear infinite`;

				this.instances.push({
					message,
					track
				});

			});

		});

		this._bindResize();

	}

	/*
	** resize
	*/

	_bindResize() {

		if (this.resizeHandler) return;

		this.resizeHandler = () =>
		{

			clearTimeout(this.resizeTimer);

			this.resizeTimer = setTimeout(() =>
			{

				this.unload();
				this.load();

			}, 200);

		};

		window.addEventListener('resize', this.resizeHandler);

	}

	/*
	** reset track
	*/

	_resetTrack (track) {

		track.style.animation = 'none';
		track.style.removeProperty('animation');

		track.style.removeProperty('--marquee-distance');
		track.style.removeProperty('animation-duration');

		track.querySelectorAll('[aria-hidden="true"]').forEach((el) =>
		{
			el.remove();
		});
	}

	/*
	** unload
	*/

	unload() {

		this.instances.forEach(({ track }) =>
		{
			this._resetTrack(track);
		});

		this.instances = [];

		if (this.resizeHandler)
		{
			window.removeEventListener('resize', this.resizeHandler);
			this.resizeHandler = null;
		}

		if (this.resizeTimer)
		{
			clearTimeout(this.resizeTimer);
			this.resizeTimer = null;

		}

	}

}